import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

export const iconStyle = ({ theme, isActive }) => ({
  color: isActive ? theme.palette.primary.iconSelected : 'inherit',
  width: '25px',
  height: '25px',

});

export const StyledMapButton = styled(Button)(({ theme }) => ({
  margin: 0,
  padding: '6px',
  minWidth: '100%',
  "& .MuiButton-startIcon": { margin: 0 },
  background: theme.palette.primary.main,
  width: '100%',
  justifyContent: 'flex-start',
  padding: '8px',
  marginBottom: '3px',
  color: theme.palette.primary.white,
  border: 'none',
  fontWeight: '600',
  transition: 'background-color 0.3s ease',
  '&:hover': {
    backgroundColor: theme.palette.primary.buttonSelected,
    border: 'none'
  },
}));